<template>
    <div class="container py-5" style="max-width:680px">
        <h2 v-if="formTitle" class="nch-suggestion__title">{{ formTitle }}</h2>

        <div v-if="sent" class="nch-suggestion__success">
            <i class="mdi mdi-check-circle"></i>
            <p>{{ successMessage }}</p>
            <button class="nch-suggestion__btn" @click="resetForm">Enviar outra</button>
        </div>

        <form v-else class="nch-suggestion__form" @submit.prevent="submit">
            <label class="nch-suggestion__label">
                Nome <span class="nch-suggestion__optional">(opcional)</span>
                <input v-model="form.name" type="text" class="nch-suggestion__input" maxlength="255" />
            </label>

            <label class="nch-suggestion__check">
                <input v-model="form.has_camara_link" type="checkbox" />
                Tenho vínculo com a câmara
            </label>

            <label v-if="form.has_camara_link" class="nch-suggestion__label">
                Qual vínculo?
                <input v-model="form.camara_link_detail" type="text" class="nch-suggestion__input" maxlength="255" />
            </label>

            <label class="nch-suggestion__label">
                Mensagem
                <textarea v-model="form.message" rows="5" class="nch-suggestion__input" maxlength="5000" required></textarea>
            </label>

            <Captcha ref="captcha"></Captcha>

            <p v-if="error" class="nch-suggestion__error">{{ error }}</p>

            <button type="submit" class="nch-suggestion__btn" :disabled="sending">
                {{ sending ? 'Enviando...' : submitLabel }}
            </button>
        </form>
    </div>
</template>

<script>
import Captcha from '../Common/Captcha';

export default {
    name: 'SuggestionPage',

    components: { Captcha },

    props: {
        config: { type: Object, default: () => ({}) },
        slug: { type: String, required: true },
    },

    data() {
        return {
            sending: false,
            sent: false,
            error: '',
            form: { name: '', has_camara_link: false, camara_link_detail: '', message: '' },
        };
    },

    computed: {
        formTitle() { return this.config.form_title || 'Envie sua sugestão'; },
        submitLabel() { return this.config.submit_label || 'Enviar sugestão'; },
        successMessage() { return this.config.success_message || 'Obrigado! Sua sugestão foi enviada.'; },
    },

    methods: {
        async submit() {
            this.error = '';
            if (!this.form.message.trim()) { this.error = 'A mensagem é obrigatória.'; return; }
            if (this.form.has_camara_link && !this.form.camara_link_detail.trim()) {
                this.error = 'Informe qual é o seu vínculo com a câmara.';
                return;
            }
            const captchaOk = await this.$refs.captcha.send();
            if (!captchaOk) { this.error = 'Verificação de segurança inválida.'; return; }
            this.sending = true;
            window.axios.post(`/p/${this.slug}/suggestions`, {
                name: this.form.name || null,
                has_camara_link: this.form.has_camara_link,
                camara_link_detail: this.form.has_camara_link ? this.form.camara_link_detail : null,
                message: this.form.message,
            }).then(() => { this.sent = true; })
              .catch(err => {
                  this.error = (err.response && err.response.data && err.response.data.message)
                      || 'Não foi possível enviar. Tente novamente.';
              })
              .finally(() => { this.sending = false; });
        },
        resetForm() {
            this.sent = false;
            this.error = '';
            this.form = { name: '', has_camara_link: false, camara_link_detail: '', message: '' };
        },
    },
};
</script>

<style scoped>
.nch-suggestion__title { font-weight: 700; margin-bottom: 1.2rem; color: var(--page-text, #212121); }
.nch-suggestion__form { display: flex; flex-direction: column; gap: 16px; }
.nch-suggestion__label { display: flex; flex-direction: column; gap: 6px; font-weight: 600; color: var(--page-text, #212121); }
.nch-suggestion__optional { font-weight: 400; color: var(--page-text-secondary, #9e9e9e); font-size: 0.85rem; }
.nch-suggestion__input {
    background: var(--page-surface, #f5f5f5);
    border: 1.5px solid var(--page-border, #e0e0e0);
    border-radius: 10px; padding: 10px 12px;
    color: var(--page-text, #212121); font-size: 0.95rem; font-weight: 400;
    outline: none; transition: border-color 0.18s;
}
.nch-suggestion__input:focus { border-color: var(--page-accent, #1976d2); }
.nch-suggestion__check { display: flex; align-items: center; gap: 8px; font-weight: 600; color: var(--page-text, #212121); cursor: pointer; }
.nch-suggestion__btn {
    align-self: flex-start;
    background: var(--page-accent, #1976d2); color: var(--page-accent-text, #fff);
    border: none; border-radius: 24px; padding: 11px 26px; font-weight: 700; cursor: pointer;
}
.nch-suggestion__btn:disabled { opacity: 0.6; cursor: default; }
.nch-suggestion__error { color: #d32f2f; font-size: 0.88rem; margin: 0; }
.nch-suggestion__success { text-align: center; padding: 2rem 0; color: var(--page-text, #212121); }
.nch-suggestion__success i { font-size: 3rem; color: var(--page-accent, #1976d2); }
</style>
